<template>
    <h1 class="custom-h1" block>Über...</h1>
    <v-card>
        <v-tabs v-model="tab" align-tabs="center" color="rgba(200,255,200,0.4)">
            <v-tab v-for="item in tabs" :key="item">{{ item }}</v-tab>
        </v-tabs>

        <v-window v-model="tab">
            <v-window-item>
                <v-container>
                    <v-row>
                        <v-col cols="10">
                            <p class="body-1" style="margin-top: -5px; margin-bottom: -70px;">
                                Die aktuelle Version ist <b>{{ version }}</b><i> (vom {{
                                    versionVon }})</i>
                            </p>
                        </v-col>
                    </v-row>
                </v-container>
                <v-container>
                    <iframe src="https://cerulean-tanuki-dfffed.netlify.app/" width="100%" height="1200px"
                        style="border: none;"></iframe>
                </v-container>
            </v-window-item>
            <v-window-item>
                <h2 class="custom-h2" block>mich</h2>
                <v-container>
                    <v-row>
                        <v-col cols="10">
                            <p class="body-1">
                                Mein Name ist Timo, ich bin 39 Jahre alt, stolzer Vater von zwei Kindern und lebe in
                                Stuttgart.
                                Meine Leidenschaft für Pen-&-Paper-Rollenspiele entflammte bereits in der dritten
                                Klasse, und seitdem hat sie mich nicht mehr losgelassen.
                            </p>
                            <p class="body-1">
                                Durch die Verantwortung als Vater finde ich mich oft in der Situation wieder, dass ich
                                meine Rollenspielabenteuer digital erleben muss.
                                Diese Notwendigkeit hat mich dazu motiviert, ständig nach Wegen zu suchen, um die
                                digitale Rollenspielerfahrung zu verbessern.
                            </p>
                            <p class="body-1">
                                Als Hobby-Informatiker stelle ich mich der Herausforderung, Programmierprojekte zu
                                realisieren, um Lösungen für mich und die Community zu entwickeln.
                                Auch wenn jedes Projekt für mich eine große Herausforderung darstellt, treibt mich die
                                Leidenschaft für das Rollenspiel und die Freude am Lernen und Entwickeln immer wieder
                                an, Neues zu erschaffen und zu teilen.
                            </p>
                        </v-col>
                        <v-col cols="2">
                            <v-img :src="require('@/assets/Bilder/TNo2.png')" />
                        </v-col>
                    </v-row>
                </v-container>
            </v-window-item>
            <v-window-item>
                <h2 class="custom-h2" block>Impressum</h2>
                <v-container>
                    <v-row>
                        <v-col>
                            <p class="body-1">
                                <b>Timo Novotny Digitale Services</b>
                                <br>
                                Inhaber: Timo Novotny
                                <br>
                                Steigstr. 48, 70565 Stuttgart
                                <br>
                                Deutschland
                                <br><br>
                                <a href="mailto:timo.novotny@stackrelay.de">E-Mail</a>
                                <br>
                                <a href="https://www.stackrelay.de">StackRelay</a>
                            </p>
                        </v-col>
                    </v-row>
                </v-container>
            </v-window-item>
            <v-window-item>
                <h2 class="custom-h2" block>Spenden</h2>
                <v-container>
                    <v-row>
                        <v-col>
                            <p class="body-1">
                                Hi, mich freut es, wenn Du rpg-troll gut findest. Für die Entwicklung geht jede Menge
                                Cafe drauf.
                            </p>
                            <p style="margin-bottom: 33px;">
                                Falls Du Lust hast, mir eine kleine Spende zukommen zu lassen kannst du das gerne
                                machen. Ich freue mich über jeden kleinen Beitrag.
                            </p>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <p>
                                Paypal.me Link: <a href="https://www.paypal.com/paypalme/timonovotny">Paypal</a>
                            </p>
                            <v-img width="250" style="margin-top: 25px;"
                                :src="require('@/assets/Bilder/paypalqr.png')" />
                        </v-col>
                        <v-col>
                            <p>
                                Bitcoin Lightning Wallet Adresse: timonovotny@walletofsatoshi.com
                            </p>
                            <v-img width="250" style="margin-top: 25px;"
                                :src="require('@/assets/Bilder/lnurlqr.png')" />
                        </v-col>
                    </v-row>
                </v-container>
            </v-window-item>
            <v-window-item>
                <h2 class="custom-h2" block>Datenschutzerklärung</h2>
                <v-container>
                    <v-row>
                        <v-col>
                            <h3 class="custom-h3">Verantwortlicher</h3>
                            <p class="body-1">
                                Der Verantwortliche für die Datenverarbeitung auf dieser Website ist Timo Novotny,
                                Steigstr. 48, 70565 Stuttgart. Bei Fragen zum Datenschutz erreichen Sie uns per <a
                                    href="mailto:t.novotny.tnds@gmail.com">t.novotny.tnds@gmail.com</a> oder Telefon
                                +49-176-23735517.
                            </p>
                            <h3 class="custom-h3">Art der erhobenen Daten</h3>
                            <p class="body-1">
                                Wir erheben und speichern lediglich Ihre E-Mail-Adresse, die Sie bei der Registrierung
                                oder Authentifizierung auf unserer Website angeben. Darüber hinaus werden nur fiktive
                                Charakterinformationen gespeichert. Es sollen ausdrücklich nur fiktive
                                Charakterinformationen angegeben werden. Bitte hinterlegen Sie keine Informationen über
                                echte Personen.
                            </p>
                            <h3 class="custom-h3">Hintergrund</h3>
                            <p class="body-1">
                                Die Erfassung der E-Mail-Adresse dient ausschließlich der Authentifizierung von Nutzern,
                                um den Zugang zu bestimmten Bereichen der Website zu ermöglichen.
                            </p>
                            <h3 class="custom-h3">Umgang</h3>
                            <p class="body-1">
                                Ihre E-Mail-Adresse wird vertraulich behandelt und auf keinen Fall für Werbezwecke
                                verwendet oder an Dritte weitergegeben.
                            </p>
                            <h3 class="custom-h3">Rechtsgrundlage</h3>
                            <p class="body-1">
                                Die Verarbeitung der E-Mail-Adresse basiert auf Ihrer Einwilligung gemäß Art. 6 Abs. 1
                                lit. a DSGVO. Durch die Nutzung der Funktionen der Website willigen Sie automatisch der
                                Verarbeitung der angegeben Daten ein.
                            </p>
                            <h3 class="custom-h3">Speicherdauer</h3>
                            <p class="body-1">
                                Ihre E-Mail-Adresse wird gespeichert, solange Ihr Konto aktiv ist. Nach der Löschung
                                Ihres Kontos werden Ihre Daten umgehend gelöscht.
                            </p>
                            <h3 class="custom-h3">Betroffenenrechte</h3>
                            <p class="body-1">
                                Ihnen stehen gemäß DSGVO verschiedene Rechte zu, darunter das Recht auf Auskunft,
                                Berichtigung, Löschung Ihrer Daten sowie das Recht, die Einwilligung zur
                                Datenverarbeitung zu widerrufen.
                            </p>
                            <h3 class="custom-h3">Beschwerdenrechte</h3>
                            <p class="body-1">
                                Sie haben das Recht, sich bei der zuständigen Aufsichtsbehörde zu beschweren, wenn Sie
                                der Ansicht sind, dass die Verarbeitung Ihrer Daten nicht rechtmäßig erfolgt.
                            </p>
                            <h3 class="custom-h3">Gewährleistung des Schutzes</h3>
                            <p class="body-1">
                                Wir ergreifen technische und organisatorische Maßnahmen, um die Sicherheit Ihrer Daten
                                zu gewährleisten und sie vor unbefugtem Zugriff zu schützen. Beachten Sie, dass
                                rpg-troll.de eine Hobby-Seite ist.
                            </p>
                            <h3 class="custom-h3">Tools</h3>
                            <h4 class="custom-h4">Google Firebase</h4>
                            <p class="body-1">
                                Auf unserer Website nutzen wir Google Firebase, insbesondere den Firebase Authentication
                                Service, für die Authentifizierung von Nutzern. Dies macht es notwendig, dass Ihre
                                E-Mail-Adresse und Ihr Passwort auf Servern von Google gespeichert werden, um Ihnen den
                                Zugang zu unserem Dienst zu ermöglichen. Google Firebase ist eine Entwicklungsplattform
                                für mobile und Webanwendungen, die von Google LLC angeboten wird. Die Verwendung von
                                Firebase Authentication hilft uns, eine sichere Authentifizierung zu gewährleisten und
                                betrügerische Nutzungsversuche zu minimieren. Weitere Informationen zum Datenschutz bei
                                der Verwendung von Google Firebase finden Sie in der Datenschutzerklärung von Google:
                                https://www.google.com/policies/privacy/.
                            </p>
                            <h4 class="custom-h4">Discrod Web API</h4>
                            <p class="body-1">
                                Zusätzlich zur Nutzung von Google Firebase setzen wir die Discord Web API ein, um
                                Nachrichten in Textkanäle auf Discord-Server zu pushen. Dies ermöglicht es unseren
                                Usern, Würfelergebnisse direkt in Discord Textkanäle zu pushen.. Bei der Nutzung der
                                Discord Web API kann es zur Übermittlung von Daten an die Server von Discord kommen,
                                unter Umständen einschließlich Informationen, die Sie uns zur Verfügung stellen. Discord
                                ist ein Kommunikationsdienst, der von Discord Inc. betrieben wird. Weitere Informationen
                                zum Datenschutz bei Discord finden Sie in der Datenschutzerklärung von Discord:
                                https://discord.com/privacy.
                            </p>
                            <h4 class="custom-h4">Hosting by https://www.netlify.com/</h4>
                            <p class="body-1">
                                Unsere Website wird gehostet durch Netlify, Inc. Netlify ist ein Hosting- und
                                Backend-Service, der speziell für Webprojekte entwickelt wurde und die Einhaltung hoher
                                Datenschutz- und Sicherheitsstandards gewährleistet. Als Hosting-Dienstleister bietet
                                Netlify die notwendige Infrastruktur und Technologie, um unsere Website im Internet
                                verfügbar und zugänglich zu machen.
                                <br><br>
                                Im Rahmen des Hostings können durch Netlify technische Daten erfasst werden, wie z.B.
                                IP-Adressen von Besuchern, zum Zwecke der Netzwerksicherheit und zur Bereitstellung und
                                Verbesserung ihres Services. Diese Datenverarbeitung erfolgt im Einklang mit den
                                geltenden Datenschutzgesetzen und der Datenschutzerklärung von Netlify.
                                <br><br>
                                Weitere Informationen zum Datenschutz bei Netlify finden Sie in der Datenschutzerklärung
                                von Netlify unter: https://www.netlify.com/privacy/.
                            </p>
                            <h4 class="custom-h4">Domain-Registrierung by https://www.united-domains.de/</h4>
                            <p class="body-1">
                                Unsere Domain ist registriert bei United Domains AG, einem führenden Anbieter für
                                Domain-Registrierung. United Domains bietet Dienstleistungen rund um die Registrierung
                                und Verwaltung von Domains an und legt großen Wert auf Datenschutz und Datensicherheit.
                                <br><br>
                                Im Rahmen der Domain-Registrierung und -Verwaltung können durch United Domains Daten
                                erfasst werden, die für die Registrierung und technische Einrichtung der Domain
                                notwendig sind. Dies umfasst unter Umständen auch personenbezogene Daten wie
                                Kontaktinformationen des Domain-Inhabers. United Domains verarbeitet diese Daten in
                                Übereinstimmung mit den geltenden Datenschutzgesetzen.
                                <br><br>
                                Weitere Informationen zum Datenschutz bei United Domains finden Sie in deren
                                Datenschutzerklärung unter:
                                https://www.united-domains.de/datenschutz/">https://www.united-domains.de/datenschutz/
                            </p>
                            <h4 class="custom-h4">TiddlyWiki (https://tiddlywiki.com/)</h4>
                            <p class="body-1">
                                Auf unserer Website verwenden wir TiddlyWiki zur Einbettung und Darstellung bestimmter
                                Inhalte, wie z.B. Changelogs und Featurebeschreibungen. TiddlyWiki ist eine
                                Open-Source-Software für die Erstellung von selbstverwalteten Wiki-Seiten, die lokal
                                im Browser verarbeitet werden.
                                <br><br>
                                Dabei werden keine personenbezogenen Daten an TiddlyWiki selbst oder an Dritte
                                übermittelt. Alle Inhalte werden direkt auf unserer Website gehostet und innerhalb
                                der Seite angezeigt, ohne dass externe Serveranfragen an TiddlyWiki.com oder andere
                                Dritte erfolgen. Die Nutzung von TiddlyWiki dient ausschließlich der besseren
                                Strukturierung
                                und Präsentation von Informationen auf unserer Website.
                            </p>
                            <h4 class="custom-h4">Tracking- und Analyse-Tools</h4>
                            <p>
                                Unsere Website setzt keine Tracking- oder Analyse-Tools ein.
                            </p>
                            <h3 class="custom-h3">Datenweitergabe</h3>
                            <p class="body-1">
                                Eine Weitergabe Ihrer Daten an Dritte erfolgt nicht, es sei denn, dies ist gesetzlich
                                erforderlich oder Sie haben ausdrücklich eingewilligt.
                            </p>
                            <h3 class="custom-h3">Datenübermittlung ins Ausland</h3>
                            <p class="body-1">
                                Eine Übermittlung Ihrer Daten ins Ausland findet nicht statt.
                            </p>
                            <h3 class="custom-h3">Verwendete Entwicklungstools</h3>
                            <p class="body-1">
                                Unsere Website wurde unter verwendung moderner Webentwicklungstechnologien und Framewors
                                erstellt. Beachten Sie dass die keinen Einfluss auf die Erfassung personenbezogener
                                Daten hat. Dies ist ein rein Informativer Abschnitt:
                            </p>
                            <h4 class="custom-h4">Vue.js</h4>
                            <p class="body-1">
                                <strong>Vue.js</strong> ist ein progressives JavaScript-Framework, das für den Aufbau
                                benutzerfreundlicher und interaktiver Web-Oberflächen verwendet wird. Es ermöglicht uns,
                                reaktive Komponenten in unserer Webanwendung effizient zu erstellen und zu verwalten.
                            </p>
                            <h4 class="custom-h4">Vuetify</h4>
                            <p class="body-1">
                                <strong>Vuetify</strong> ist ein Vue UI Framework, das eine Vielzahl von vorgefertigten
                                Komponenten und Material Design-Elementen bietet. Durch die Verwendung von Vuetify
                                können wir ein konsistentes und ansprechendes Design auf unserer Website sicherstellen,
                                wodurch die Benutzererfahrung verbessert wird.
                            </p>
                            <h4 class="custom-h4">Vuex</h4>
                            <p class="body-1">
                                <strong>Vuex</strong> ist ein Zustandsverwaltungs-Pattern und -Bibliothek für
                                Vue.js-Anwendungen. Es dient als zentrales Repository für alle Komponenten in einer
                                Anwendung, ermöglicht den Zustandsaustausch zwischen Komponenten und hilft uns, die
                                Zustandsverwaltung unserer Webanwendung effizient zu handhaben.
                            </p>
                        </v-col>
                    </v-row>
                </v-container>
            </v-window-item>
        </v-window>
    </v-card>
</template>

<script>
export default {
    data() {
        return {
            tab: 0,
            tabs: ['RPG Troll', 'mich', 'Impressum', 'Spenden', 'Datenschutzerklärung']
        }
    },

    computed: {
        version() {
            return this.$store.state.Version
        },
        versionVon() {
            return this.$store.state.VersionVon
        },
    },

    created() {
        if (this.$route.path.includes('/impressum')) {
            this.tab = 2
        }
    }

}
</script>

<style>
.body-1 {
    margin-bottom: 25px;
}

.body-2 {
    margin-bottom: 6px;
}
</style>